<template>
  <div class="editPage">
    <div class="head flex-rowl">
      <div class="icon"><i class="iconfont icon-wodetuandui"></i></div>
      <div class="con">
        <p>企业/团队信息</p>
        <p>企业/业务海报模板管理</p>
      </div>
    </div>
    <div class="myInfoList">
      <div class="infoItem upload_wrap column">
        <div class="label">邀请好友海报模板</div>
        <div class="upload_box flex-rowc">
          <template v-if="initData.poster_invite">
            <van-image height="100%" :src="baseUrl + initData.poster_invite" />
            <div class="del-icon" @click="handleDelImg(1)">
              <van-icon name="delete-o" />
            </div>
          </template>
          <div class="no flex-rowc" v-else>
            <van-icon name="plus" size="50px" color="#ccc" />
            <input
              type="file"
              class="uploadInput"
              ref="fileInput1"
              multiple="multiple"
              accept="image/png,image/jpeg,image/jpg"
              @change="handleChooseImg(1)"
            />
          </div>
        </div>
        <div class="pic_tip">图片大小不超过5M，仅限JPG、JPEG或PNG图片文件</div>
      </div>
      <div class="infoItem upload_wrap column">
        <div class="label">推荐注册海报模板（业务名片）</div>
        <div class="upload_box flex-rowc">
          <template v-if="initData.poster_reg">
            <van-image  height="100%" :src="baseUrl + initData.poster_reg" />
            <div class="del-icon" @click="handleDelImg(2)">
              <van-icon name="delete-o" />
            </div>
          </template>
          <div class="no flex-rowc" v-else>
            <input
              type="file"
              class="uploadInput"
              ref="fileInput2"
              multiple="multiple"
              accept="image/png,image/jpeg,image/jpg"
              @change="handleChooseImg(2)"
            />
            <van-icon name="plus" size="50px" color="#ccc" />
          </div>
        </div>
        <div class="pic_tip">图片大小不超过5M，仅限JPG、JPEG或PNG图片文件</div>
      </div>
      <div class="agree_wrapper flex-rowl" v-if="false">
        <van-checkbox
          v-model="checked"
          shape="square"
          checked-color="#F62560"
          class="check"
        />WINK SShoWP的 <agree></agree>
      </div>
      <div class="primary-button" @click="handleSave">保存</div>
      <div class="primary-button return" @click="handleReturn"><i class="iconfont icon-yuyinjiantou"></i> 返回</div>
    </div>


    <!-- 弹窗 start -->
    <van-popup v-model="isShow" position="bottom" :style="{ height: '40%' }">
      <!-- 行业标签1 -->
      <div v-if="isType == 1">
        <van-picker
          show-toolbar
          :columns="oneLabelList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          @change="onChange"
          :loading="loading"
          v-if="oneLabelList.length > 0"
        />
        <van-empty
          v-else-if="oneLabelList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 2">
        <van-picker
          show-toolbar
          :columns="twoLabelList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          @change="onChange"
          :loading="loading"
          v-if="twoLabelList.length > 0"
        />
        <van-empty
          v-else-if="twoLabelList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 3">
        <van-picker
          show-toolbar
          :columns="threeLabelList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          @change="onChange"
          :loading="loading"
          v-if="threeLabelList.length > 0"
        />
        <van-empty
          v-else-if="threeLabelList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 4">
        <van-picker
          show-toolbar
          :columns="provinceList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          @change="onChange"
          :loading="loading"
          v-if="provinceList.length > 0"
        />
        <van-empty
          v-else-if="provinceList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 5">
        <van-picker
          show-toolbar
          :columns="cityList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          @change="onChange"
          :loading="loading"
          v-if="cityList.length > 0"
        />
        <van-empty
          v-else-if="cityList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
      <div v-else-if="isType == 6">
        <van-picker
          show-toolbar
          :columns="areaList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          @change="onChange"
          :loading="loading"
          v-if="areaList.length > 0"
        />
        <van-empty
          v-else-if="areaList.length == 0 && !loading"
          description="暂无选项"
        />
      </div>
    </van-popup>
    <!-- 弹窗 end -->
  </div>
</template>

<script>
import storage from "../../utils/storage";
import {
  getQyFirstLevelLabel,
  getQyTwoLevelLabel,
  getQyThreeLevelLabel,
  editCompany,
  getCompanyInfo,
} from "../../api/company";
import { getProvince, getCity, getArea, uploadPosterImage } from "../../api/api";
import agree from "../../components/Agreement.vue";
export default {
  name: "poster",
  components: {
    agree,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      // 提交数据
      initData: {
        openid: "",
        qyname: "",
        qyename: "",
        logo: "",
        uscc: "",
        linkname: "",
        linkphone: "",
        linkemail: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        label1: "",
        label2: "",
        label3: "",
        douyinid: "",
        redbookid: "",
        dianpingid: "",
        pic: "",
        poster_invite: '',
        poster_reg: ''
      },
      isReadonlyQ: false,

      //   一级标签
      oneLabelList: [],
      oneLabelText: "",
      //   二级标签
      twoLabelList: [],
      twoLabelText: "",
      // 三级标签
      threeLabelList: [],
      threeLabelText: "",

      provinceList: [],
      provinceTxt: "",
      cityList: [],
      cityTxt: "",
      areaList: [],
      areaTxt: "",

      loading: true,
      columns: [],
      isType: 1,
      isShow: false,

      uploadType: 1,
      checked: false,
    };
  },
  watch: {
    'initData.uscc' (newValue) {
      this.initData.uscc = newValue.replace(/[\u4e00-\u9fa5/\s+/]|[^a-zA-Z0-9\u4E00-\u9FA5]/g, "")
    },
    'initData.linkname' (newValue) {
      this.initData.linkname = newValue.replace(/[0-9]/g, "")
    }
  },
  created() {
    this.getCompanyInfo();
  },
  methods: {
    afterRead() {},
    getCompanyInfo() {
      let openid = this.$store.state.OPENID;
      console.log(openid);
      // return
      getCompanyInfo({ openid, openid_qycreate: openid }).then((res) => {
        this.initData.qyname = res.qyname ? res.qyname : "";
        this.isReadonlyQ = res.qyname ? true : false
        this.initData.qyename = res.qyename ? res.qyename : "";
        this.initData.logo = res.logo ? res.logo : "";
        this.initData.uscc = res.uscc ? res.uscc : "";
        this.initData.linkname = res.linkname ? res.linkname : "";
        this.initData.linkphone = res.linkphone ? res.linkphone : "";
        this.initData.linkemail = res.linkemail ? res.linkemail : "";
        this.initData.province = res.province ? res.province : "";
        this.provinceTxt = res.provincename ? res.provincename : "";
        this.initData.city = res.city ? res.city : "";
        this.cityTxt = res.cityname ? res.cityname : "";
        this.initData.area = res.area ? res.area : "";
        this.areaTxt = res.arearname ? res.arearname : "";
        this.initData.addr = res.addr ? res.addr : "";
        this.initData.label1 = res.label1 ? res.label1 : "";
        this.oneLabelText = res.label1_name ? res.label1_name : "";
        this.initData.label2 = res.label2 ? res.label2 : "";
        this.twoLabelText = res.label2_name ? res.label2_name : "";
        this.initData.label3 = res.label3 ? res.label3 : "";
        this.threeLabelText = res.label3_name ? res.label3_name : "";
        this.initData.douyinid = res.douyinid ? res.douyinid : "";
        this.initData.redbookid = res.redbookid ? res.redbookid : "";
        this.initData.dianpingid = res.dianpingid ? res.dianpingid : "";
        this.initData.pic = res.pic ? res.pic : "";
        this.initData.poster_invite = res.poster_invite ? res.poster_invite : "";
        this.initData.poster_reg = res.poster_reg ? res.poster_reg : "";
        this.initData.openid = res.openid ? res.openid : storage.get("OPENID");
      });
    },
    // 获取企业一级标签
    getQyFirstLevelLabel() {
      getQyFirstLevelLabel().then((res) => {
        let newLabel = [];
        res.forEach((v) => {
          newLabel.push({
            text: v.labelname,
            id: v.id,
          });
        });
        this.oneLabelList = newLabel;
        this.loading = false;
      });
    },
    // 获取二级标签
    getQyTwoLevelLabel() {
      getQyTwoLevelLabel(this.initData.label1).then((res) => {
        let newLabel = [];
        res.forEach((v) => {
          newLabel.push({
            text: v.labelname,
            id: v.id,
          });
        });
        this.twoLabelList = newLabel;
        this.loading = false;
      });
    },
    // 获取三级标签
    getQyThreeLevelLabel() {
      getQyThreeLevelLabel(this.initData.label2).then((res) => {
        let newLabel = [];
        res.forEach((v) => {
          newLabel.push({
            text: v.labelname,
            id: v.id,
          });
        });
        this.threeLabelList = newLabel;
        this.loading = false;
      });
    },
    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        let newProvince = [];
        res.forEach((v) => {
          newProvince.push({
            text: v.areaname,
            id: v.areaid,
          });
        });
        this.provinceList = newProvince;
        this.loading = false;
        if (isClick) {
          this.isShow = true;
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.initData.province).then((res) => {
        let newcity = [];
        res.forEach((v) => {
          newcity.push({
            text: v.cityname,
            id: v.cityid,
          });
        });
        this.cityList = newcity;
        this.loading = false;
        if (isClick && newcity.length > 0) {
          this.isShow = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },
    // 获取区域
    getArea(isClick) {
      getArea(this.initData.city).then((res) => {
        let newarea = [];
        res.forEach((v) => {
          newarea.push({
            text: v.addrname,
            id: v.addrid,
          });
        });
        this.areaList = newarea;
        this.loading = false;
        if (isClick && newarea.length > 0) {
          this.isShow = true;
        } else {
          this.$toast("暂无数据");
        }
      });
    },

    onConfirm(e) {
      let { isType } = this;
      if (isType == 1) {
        this.oneLabelText = e.text;
        this.initData.label1 = e.id;
        this.twoLabelText = "";
        this.initData.label2 = "";
        this.threeLabelText = "";
        this.initData.label3 = "";
      } else if (isType == 2) {
        this.twoLabelText = e.text;
        this.initData.label2 = e.id;
        this.threeLabelText = "";
        this.initData.label3 = "";
      } else if (isType == 3) {
        this.threeLabelText = e.text;
        this.initData.label3 = e.id;
      } else if (isType == 4) {
        this.provinceTxt = e.text;
        this.initData.province = e.id;
        this.areaTxt = "";
        this.initData.area = "";
        this.cityTxt = "";
        this.initData.city = "";
        this.initData.addr = "";
      } else if (isType == 5) {
        this.cityTxt = e.text;
        this.initData.city = e.id;
        this.areaTxt = "";
        this.initData.area = "";
        this.initData.addr = "";
      } else if (isType == 6) {
        this.areaTxt = e.text;
        this.initData.area = e.id;
        this.initData.addr = "";
      }
      this.loading = true;
      this.isShow = false;
    },
    onChange() {},
    // 显示弹窗
    handleShow(type) {
      let { oneLabelText, twoLabelText, provinceTxt, cityTxt } = this;
      this.isType = type;
      if (type == 1) {
        this.getQyFirstLevelLabel();
        this.isShow = true;
      } else if (type == 2) {
        if (oneLabelText == "") {
          this.$toast("请选择一级标签");
          return;
        }
        this.getQyTwoLevelLabel();
        this.isShow = true;
      } else if (type == 3) {
        if (oneLabelText == "") {
          this.$toast("请选择一级标签");
          return;
        } else if (twoLabelText == "") {
          this.$toast("请选择二级标签");
          return;
        }
        this.getQyThreeLevelLabel();
        this.isShow = true;
      } else if (type == 4) {
        this.getProvince(true);
      } else if (type == 5) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        this.getCity(true);
      } else if (type == 6) {
        if (provinceTxt == "") {
          this.$toast("请选择省/直辖市");
          return;
        }
        if (cityTxt == "") {
          this.$toast("请选择城市");
          return;
        }
        this.getArea(true);
      }
    },

    // 上传图片
    handleChooseImg(uploadType) {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      const formData = new FormData();
      if (uploadType == 1) {
        if (this.verificationPicFile(this.$refs.fileInput1.files)) {
          formData.append("imgfile", this.$refs.fileInput1.files[0]);
        } else {
          this.initData.poster_invite = "";
          return;
        }
      } else if (uploadType == 2) {
        if (this.verificationPicFile(this.$refs.fileInput2.files)) {
          formData.append("imgfile", this.$refs.fileInput2.files[0]);
        } else {
          this.initData.poster_reg = "";
          return;
        }
      }
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          if (uploadType == 1) {
            this.initData.poster_invite = res.code;
          } else if (uploadType == 2) {
            this.initData.poster_reg = res.code;
          }
          toast.clear();
        } else {
          this.$toast.fail("上传失败");
        }
      });
    },
    // 图片大小限制
    verificationPicFile(file) {
      var fileSize = 0;
      var fileMaxSize = 1024 * 5; //5M
      if (file) {
        fileSize = file[0].size;
        var size = fileSize / 1024;
        if (size > fileMaxSize) {
          this.$toast("上传失败，图片文件大小超过限制！");
          return false;
        } else if (size <= 0) {
          this.$toast("文件大小不能为0M！");
          return false;
        } else {
          if (file[0].type != "image/png" && file[0].type != "image/jpg" && file[0].type != "image/jpeg") {
            this.$toast("上传失败，文件格式不符合标准，仅限JPG、JPEG或PNG图片文件！");
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },

    // 删除图
    handleDelImg(type) {
      if (type == 1) {
        this.initData.poster_invite = "";
      } else if (type == 2) {
        this.initData.poster_reg = "";
      }
    },

    // 返回上一页
    handleReturn() {
      this.$router.go(-1);
    },
    handleSave() {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let params = this.initData;
      editCompany(params).then((res) => {
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            toast.clear();
            this.$router.back();
          }, 1800);
        } else {
          this.$toast.fail(res.message);
          toast.clear();
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.editPage {
  padding-bottom: 240px;
  box-sizing: border-box;
  font-size: 28px;
  background: #fafafa;
  .head {
    padding: 145px 0 30px 75px;
    box-sizing: border-box;
    .iconfont {
      font-size: 46px;
      margin-right: 15px;
    }
    p {
      font-size: 30px;
      color: #333333;
      &:last-child {
        font-size: 20px;
        margin-top: 5px;
      }
    }
  }
  /deep/ .van-cell {
    padding: 0;
    background: none;
  }
  .myInfoList {
    background: #fff;
    // padding: 40px 42px 120px;
    padding: 75px 75px 120px;
    // width: 600px;
    .infoItem {
      margin: 0 0 42px;
      font-size: 24px;
      .label {
        color: #444444;
        white-space: nowrap;
        // margin-right: 40px;
        margin-bottom: 22px;
        span {
          color: #ff0000;
          margin-right: 5px;
          margin-left: -5px;
        }
      }
      .input {
        // padding: 15px 10px 0;
        height: 55px;
        flex: 1;
        font-size: 20px;
        padding-left: 10px;
        border-bottom: 2px dashed #d9d9d9;
        .icon-yuyinjiantou {
          transform: rotate(-90deg);
          font-size: 32px;
        }
      }
      /deep/ .van-field__control {
        font-size: 12px;
      }
      .textarea {
        padding: 0 10px;
        border-bottom: 2px dashed #d9d9d9;
      }
      &.detail {
        margin-top: 74px;
        .textArea_box {
          background: #fafafa;
          padding: 10px;
          box-sizing: border-box;
        }
      }
      .pic_tip {
        font-size: 12px;
        text-align: center;
        color: #ccc;
        margin-top: 15px;
      }
    }
    .upload_wrap {
      padding-bottom: 115px;
      .label {
        margin-bottom: 66px;
      }
      .upload_box {
        width: 300px;
        height: 300px;
        margin: auto;
        border: 2px dashed #d9d9d9;
        position: relative;
        overflow: hidden;
        background: #ffffff;
        .no {
          width: 100%;
          height: 100%;
          position: relative;
          /deep/ .van-uploader,
          /deep/ .van-uploader__wrapper,
          /deep/ .van-uploader__upload {
            width: 100%;
            height: 100%;
            margin: auto;
          }
          .uploadInput {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 1001;
          }
        }
        .del-icon {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 0;
          height: 0;
          border-top: 30px solid transparent;
          border-right: 30px solid #ff0000;
          border-bottom: 30px solid red;
          border-left: 30px solid transparent;
          color: #fff;
        }
      }
    }
    .column {
      .title {
        font-size: 34px;
        font-weight: bold;
        padding: 40px 0 20px;
      }
    }
    .industry_wrap {
      margin-bottom: 90px;
    }
    .address_wrap {
      margin-bottom: 90px;
    }
  }
  .agree_wrapper {
    font-size: 20px;
    padding: 120px 0 80px 0;
    .check {
      margin-right: 15px;
    }
  }
}
</style>